(() => {
  const root = document.querySelector('[data-wll-bread-planner]');
  if (!root || root.dataset.wllPlannerReady === 'true') return;
  root.dataset.wllPlannerReady = 'true';

  const els = {
    recipeMode: root.querySelector('#recipeMode'),
    everydayPanel: root.querySelector('#everydayPanel'),
    customPanel: root.querySelector('#customPanel'),
    loaves: root.querySelector('#loaves'),
    loafChoice: root.querySelector('#loafChoice'),
    flour: root.querySelector('#flour'),
    flourDirect: root.querySelector('#flourDirect'),
    hydration: root.querySelector('#hydration'),
    hydrationDirect: root.querySelector('#hydrationDirect'),
    starterPct: root.querySelector('#starterPct'),
    starterPctDirect: root.querySelector('#starterPctDirect'),
    saltPct: root.querySelector('#saltPct'),
    saltPctDirect: root.querySelector('#saltPctDirect'),
    waterGrams: root.querySelector('#waterGrams'),
    starterGrams: root.querySelector('#starterGrams'),
    saltGrams: root.querySelector('#saltGrams'),
    starterFieldLabel: root.querySelector('#starterFieldLabel'),
    advancedToggles: root.querySelectorAll('[data-advanced-toggle]'),
    everydayTempBand: root.querySelector('#everydayTempBand'),
    everydayTempResult: root.querySelector('#everydayTempResult'),
    levainToggle: root.querySelector('#levainToggle'),
    levainSection: root.querySelector('#levainSection'),
    levainFlourPct: root.querySelector('#levainFlourPct'),
    levainWaterPct: root.querySelector('#levainWaterPct'),
    levainSeedPct: root.querySelector('#levainSeedPct'),
    levainRatioText: root.querySelector('#levainRatioText'),
    levainGramsText: root.querySelector('#levainGramsText'),
    levainTimingText: root.querySelector('#levainTimingText'),
    tempPresets: root.querySelector('#tempPresets'),
    temp: root.querySelector('#temp'),
    tempValue: root.querySelector('#tempValue'),
    tempRiseTarget: root.querySelector('#tempRiseTarget'),
    bulkDuration: root.querySelector('#bulkDuration'),
    bulkColdNote: root.querySelector('#bulkColdNote'),
    bulkFinish: root.querySelector('#bulkFinish'),
    proofMode: root.querySelector('#proofMode'),
    coldHoursField: root.querySelector('#coldHoursField'),
    coldHours: root.querySelector('#coldHours'),
    coldDuration: root.querySelector('#coldDuration'),
    coldHoursOutput: root.querySelector('#coldHoursOutput'),
    coldStatus: root.querySelector('#coldStatus'),
    proofModeCopy: root.querySelector('#proofModeCopy'),
    scheduleMode: root.querySelector('#scheduleMode'),
    bakeAtField: root.querySelector('#bakeAtField'),
    bakeAt: root.querySelector('#bakeAt'),
    bakeDateButton: root.querySelector('#bakeDateButton'),
    bakeCalendar: root.querySelector('#bakeCalendar'),
    bakeTime: root.querySelector('#bakeTime'),
    calendarPrev: root.querySelector('#calendarPrev'),
    calendarNext: root.querySelector('#calendarNext'),
    calendarMonth: root.querySelector('#calendarMonth'),
    calendarGrid: root.querySelector('#calendarGrid'),
    scheduleWarning: root.querySelector('#scheduleWarning'),
    starterState: root.querySelector('#starterState'),
    starterFeedPanel: root.querySelector('#starterFeedPanel'),
    starterFeedRatio: root.querySelector('#starterFeedRatio'),
    starterFeedTiming: root.querySelector('#starterFeedTiming'),
    starterStateNote: root.querySelector('#starterStateNote'),
    summaryMode: root.querySelector('#summaryMode'),
    summaryBatch: root.querySelector('#summaryBatch'),
    recipeTotal: root.querySelector('#recipeTotal'),
    recipeLine: root.querySelector('#recipeLine'),
    levainDetail: root.querySelector('#levainDetail'),
    nextMoveTime: root.querySelector('#nextMoveTime'),
    nextMoveTitle: root.querySelector('#nextMoveTitle'),
    nextMoveDetail: root.querySelector('#nextMoveDetail'),
    moveList: root.querySelector('#moveList'),
    timeline: root.querySelector('#timeline'),
    timelineWrap: root.querySelector('.timeline-wrap'),
    jumpNav: root.querySelector('#calculatorJumpNav'),
    jumpNavFirst: root.querySelector('#jumpNavFirst'),
    jumpNavSecond: root.querySelector('#jumpNavSecond'),
    recipeSection: root.querySelector('#recipeSection'),
    planSection: root.querySelector('#planSection'),
    actionStepsSection: root.querySelector('#actionStepsSection'),
    instructionsSection: root.querySelector('#instructionsSection'),
    bulkRiseExplainer: root.querySelector('#bulkRiseExplainer'),
    eventTooltip: root.querySelector('#eventTooltip')
  };

  const copy = {
    bulkNext: root.dataset.bulkNextTemplate,
    bulkTooltip: root.dataset.bulkTooltipTemplate,
    bulkGuide: root.dataset.bulkGuideTemplate,
    bake: root.dataset.bakeTooltip,
    activate: root.dataset.activateTooltip,
    levain: root.dataset.levainEventTooltip,
    mix: root.dataset.mixTooltip,
    shape: root.dataset.shapeTooltip,
    coldProof: root.dataset.coldProofTooltip,
    warmProof: root.dataset.warmProofTooltip
  };

  const scheduleImages = {
    starter: root.dataset.imageStarter || '',
    levain: root.dataset.imageLevain || '',
    mix: root.dataset.imageMix || '',
    bulk: root.dataset.imageBulk || '',
    shape: root.dataset.imageShape || '',
    proof: root.dataset.imageProof || '',
    bake: root.dataset.imageBake || ''
  };

  const state = {
    mode: 'everyday',
    customInitialized: false,
    starterState: 'active',
    starterFeedRatio: '1:1:1',
    everydayTempBand: '70-75',
    timelineExpanded: false,
    levain: false,
    proofMode: 'cold',
    scheduleMode: 'now',
    startNowAt: new Date(),
    calendarCursor: null
  };

  const bulkModel = {
    minTempF: 65,
    maxTempF: 80,
    referenceTempF: 75,
    referenceHours: 6,
    maxTempC: 35.9,
    b: 3.0,
    c: 0.34
  };

  const coldProofHours = [
    ...Array.from({length: 13}, (_, index) => 12 + index),
    ...Array.from({length: 8}, (_, index) => 27 + index * 3)
  ];

  const starterFeedOptions = {
    '1:1:1': {hours: 6, flourParts: 1, waterParts: 1},
    '1:2:2': {hours: 8, flourParts: 2, waterParts: 2},
    '1:3:3': {hours: 10, flourParts: 3, waterParts: 3},
    '1:4:4': {hours: 12, flourParts: 4, waterParts: 4},
    '1:5:5': {hours: 14, flourParts: 5, waterParts: 5}
  };

  const everydayTempBands = {
    '65-70': {min: 65, max: 70, planTemp: 68},
    '70-75': {min: 70, max: 75, planTemp: 74},
    '75-80': {min: 75, max: 80, planTemp: 78}
  };

  const coldDoughNote = 'Cold temperatures can increase the time up to a full 24 hours, so keep an eye on it.';

  const constants = {
    hibernationHours: 24,
    mixHours: .5,
    shapeHours: 20 / 60,
    warmProofHours: 2,
    warmProofTemp: 74,
    bakeHours: 45 / 60
  };

  function clamp(n, min, max) { return Math.min(max, Math.max(min, n)); }
  function num(input, fallback) {
    const value = Number(input.value);
    return Number.isFinite(value) ? value : fallback;
  }
  function round1(n) { return Math.round(n * 10) / 10; }
  function grams(n) { return Math.abs(n - Math.round(n)) < .05 ? `${Math.round(n)}g` : `${round1(n)}g`; }
  function addHours(date, hours) { return new Date(date.getTime() + hours * 3600000); }
  function startOfDay(date) { return new Date(date.getFullYear(), date.getMonth(), date.getDate()); }
  function formatTime(date) { return new Intl.DateTimeFormat(undefined, {hour: 'numeric', minute: '2-digit'}).format(date); }
  function formatDayShort(date) { return new Intl.DateTimeFormat(undefined, {weekday: 'short'}).format(date); }
  function formatDayTime(date) { return `${relativeDay(date)} · ${formatTime(roundToQuarter(date))}`; }
  function escapeHtml(value) { return String(value).replace(/[&<>'"]/g, char => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'}[char])); }
  function withRise(template, rise) { return String(template || '').split('{rise}').join(String(rise)); }
  function roundToQuarter(date) {
    const rounded = new Date(date);
    rounded.setSeconds(0, 0);
    rounded.setMinutes(Math.round(rounded.getMinutes() / 15) * 15);
    return rounded;
  }
  function nextDayNine() {
    const now = new Date();
    const date = new Date(now);
    date.setHours(9, 0, 0, 0);
    do date.setDate(date.getDate() + 1); while (date - now < 36 * 3600000);
    return date;
  }
  function localInputValue(date) {
    const pad = n => String(n).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
  }

  function yeastRate(tempF) {
    const tempC = (tempF - 32) * 5 / 9;
    const d = bulkModel.maxTempC - tempC;
    return Math.pow(d, bulkModel.b) * Math.exp(-bulkModel.c * d);
  }

  const referenceYeastRate = yeastRate(bulkModel.referenceTempF);

  function getChart(temp) {
    const t = clamp(temp, bulkModel.minTempF, bulkModel.maxTempF);
    const relativeRate = yeastRate(t) / referenceYeastRate;
    const h = bulkModel.referenceHours / relativeRate;
    const rise = clamp(404.5 - 4.7 * t, 30, 100);
    return {t, h, rise};
  }

  function selected(group) { return group.querySelector('[aria-pressed="true"]').dataset.value; }
  function setPressed(group, value) {
    group.querySelectorAll('button[data-value]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.value === String(value)));
    });
  }

  function syncState() {
    state.mode = selected(els.recipeMode);
    state.scheduleMode = selected(els.scheduleMode);
    state.starterState = selected(els.starterState);
    state.starterFeedRatio = selected(els.starterFeedRatio);
    state.everydayTempBand = selected(els.everydayTempBand);
    state.levain = state.mode === 'custom' && els.levainToggle.getAttribute('aria-pressed') === 'true';
    state.proofMode = state.mode === 'custom' ? selected(els.proofMode) : 'cold';

    els.everydayPanel.hidden = state.mode !== 'everyday';
    els.customPanel.hidden = state.mode !== 'custom';
    els.bakeAtField.hidden = state.scheduleMode !== 'bake';
    els.starterFeedPanel.hidden = state.starterState !== 'feed';
    els.levainSection.hidden = !state.levain;
    els.coldHoursField.hidden = state.proofMode !== 'cold';
    els.proofModeCopy.hidden = state.proofMode !== 'warm';
    if (state.scheduleMode !== 'bake') closeCalendar();
  }

  function recipeValues() {
    const loafCount = clamp(Math.round(num(els.loaves, 1)), 1, 3);
    const everyday = state.mode === 'everyday';
    const flour = everyday ? loafCount * 500 : num(els.flourDirect, 500);
    const hydration = everyday ? 70 : num(els.hydrationDirect, 70);
    const starterPct = everyday ? 10 : num(els.starterPctDirect, 10);
    const saltPct = everyday ? 2 : clamp(num(els.saltPct, 2), 0, 5);
    const starter = flour * starterPct / 100;
    const levainFlourPct = clamp(num(els.levainFlourPct, 1), 1, 10);
    const levainWaterPct = clamp(num(els.levainWaterPct, 1), 1, 10);
    const levainSeedPct = clamp(num(els.levainSeedPct, 1), 1, 10);
    const ratioTotal = levainFlourPct + levainWaterPct + levainSeedPct;
    const levainHours = Math.round(4 + 2 * (levainFlourPct / levainSeedPct));

    return {
      loafCount,
      flour,
      hydration,
      starterPct,
      saltPct,
      water: flour * hydration / 100,
      starter,
      salt: flour * saltPct / 100,
      levainFlourPct,
      levainWaterPct,
      levainSeedPct,
      levainHours,
      levainFlour: starter * levainFlourPct / ratioTotal,
      levainWater: starter * levainWaterPct / ratioTotal,
      levainSeed: starter * levainSeedPct / ratioTotal
    };
  }

  function recipeItem(label, amount) {
    return `<div class="recipe-item"><span class="recipe-item-name">${escapeHtml(label)}</span><strong>${escapeHtml(amount)}</strong></div>`;
  }

  function recipeTable(rows) {
    return rows.join('');
  }

  function setRangeProgress(input) {
    const min = Number(input.min);
    const max = Number(input.max);
    const value = Number(input.value);
    const progress = max === min ? 0 : ((value - min) / (max - min)) * 100;
    input.style.setProperty('--range-progress', `${clamp(progress, 0, 100)}%`);
  }

  function renderRecipe(values, bulk) {
    const flourText = grams(values.flour);
    const waterText = grams(values.water);
    const starterText = grams(values.starter);
    const saltText = grams(values.salt);

    els.saltPctDirect.value = String(round1(values.saltPct));
    els.waterGrams.textContent = waterText;
    els.starterGrams.textContent = starterText;
    els.saltGrams.textContent = saltText;

    const levainFlourText = grams(values.levainFlour);
    const levainWaterText = grams(values.levainWater);
    const levainSeedText = grams(values.levainSeed);
    els.levainRatioText.textContent = `${Math.round(values.levainSeedPct)}:${Math.round(values.levainFlourPct)}:${Math.round(values.levainWaterPct)}`;
    els.levainGramsText.textContent = `${levainSeedText}:${levainFlourText}:${levainWaterText}`;
    els.levainTimingText.textContent = `+${values.levainHours} hours for the levain to activate`;

    els.starterFieldLabel.textContent = state.levain ? 'Levain' : 'Starter';
    els.starterPct.setAttribute('aria-label', state.levain ? "Levain as baker's percentage" : "Starter as baker's percentage");
    els.summaryMode.textContent = state.mode === 'everyday' ? 'Everyday Recipe' : 'Custom Recipe';
    els.summaryBatch.textContent = state.mode === 'everyday'
      ? `${values.loafCount} ${values.loafCount === 1 ? 'loaf' : 'loaves'}`
      : `${grams(values.flour)} flour`;

    const doughTotal = values.flour + values.water + values.starter + values.salt;
    els.recipeTotal.textContent = `${grams(doughTotal)} total dough`;

    const doughRows = [
      recipeItem(state.levain ? 'Levain' : 'Starter', starterText),
      recipeItem('Flour', flourText),
      recipeItem('Water', waterText),
      recipeItem('Salt', saltText)
    ];

    const recipeGroups = [];

    if (state.starterState === 'feed') {
      const feed = starterFeedOptions[state.starterFeedRatio];
      const activationTarget = state.levain ? values.levainSeed : values.starter;
      const totalParts = 1 + feed.flourParts + feed.waterParts;
      const activationRows = [
        recipeItem('Starter', grams(activationTarget / totalParts)),
        recipeItem('Flour', grams(activationTarget * feed.flourParts / totalParts)),
        recipeItem('Water', grams(activationTarget * feed.waterParts / totalParts))
      ];
      recipeGroups.push(`<div class="recipe-subgroup"><p class="recipe-subhead">Starter activation <span class="recipe-subhead-note">${escapeHtml(state.starterFeedRatio)} feed</span></p>${recipeTable(activationRows)}</div>`);
    }

    if (state.levain) {
      const levainRows = [
        recipeItem('Starter', levainSeedText),
        recipeItem('Flour', levainFlourText),
        recipeItem('Water', levainWaterText)
      ];
      recipeGroups.push(`<div class="recipe-subgroup"><p class="recipe-subhead">Levain build</p>${recipeTable(levainRows)}</div>`);
      recipeGroups.push(`<div class="recipe-subgroup"><p class="recipe-subhead">Dough</p>${recipeTable(doughRows)}</div>`);
      els.levainDetail.hidden = false;
      els.levainDetail.textContent = 'Levain replaces starter in the dough recipe. The levain sliders define the build; the dough’s levain percentage sets how much you use.';
    } else if (state.starterState === 'feed') {
      recipeGroups.push(`<div class="recipe-subgroup"><p class="recipe-subhead">Dough</p>${recipeTable(doughRows)}</div>`);
      els.levainDetail.hidden = true;
      els.levainDetail.textContent = '';
    } else {
      recipeGroups.push(recipeTable(doughRows));
      els.levainDetail.hidden = true;
      els.levainDetail.textContent = '';
    }

    els.recipeLine.innerHTML = recipeGroups.join('');

    const rise = Math.round(bulk.rise);
    if (els.bulkRiseExplainer) els.bulkRiseExplainer.textContent = withRise(copy.bulkGuide, rise);
  }

  function renderEverydayTemperature() {
    const band = everydayTempBands[state.everydayTempBand];
    const midpoint = getChart(band.planTemp);
    const rise = Math.round(midpoint.rise);
    const timing = bulkTimeRange(band);
    const ending = band.max <= 70 ? ` or even longer. ${coldDoughNote}` : '.';
    els.everydayTempResult.textContent = `The dough will rise an extra ${rise}% in about ${timing}${ending}`;
  }

  function bulkTimeRange(band) {
    const low = getChart(band.min);
    const high = getChart(band.max);
    const fastHours = Math.floor(Math.min(low.h, high.h));
    const slowHours = Math.ceil(Math.max(low.h, high.h));
    return `${fastHours} - ${slowHours} hours`;
  }

  function renderAdvancedControls() {
    const coldHours = clamp(num(els.coldHours, 12), 12, 48);
    const coldIndex = coldProofHours.reduce((bestIndex, hours, index) =>
      Math.abs(hours - coldHours) < Math.abs(coldProofHours[bestIndex] - coldHours) ? index : bestIndex, 0);
    const snappedHours = coldProofHours[coldIndex];
    els.coldDuration.value = String(coldIndex);
    els.coldDuration.setAttribute('aria-valuetext', `${snappedHours} hours`);
    els.coldHoursOutput.textContent = `${snappedHours} hr`;

    if (coldHours <= 16) els.coldStatus.textContent = 'Balanced default · good flavor development with strong oven spring.';
    else if (coldHours <= 24) els.coldStatus.textContent = 'Longer cold proof · deeper flavor; spring may begin to soften.';
    else els.coldStatus.textContent = 'Extended cold proof · more sourness; expect some loss of oven spring.';

    const temp = clamp(num(els.temp, 74), 65, 80);
    els.tempValue.textContent = `${Math.round(temp)}°F`;
    els.tempPresets.querySelectorAll('button[data-value]').forEach(button => {
      button.setAttribute('aria-pressed', String(Number(button.dataset.value) === temp));
    });

    root.querySelectorAll('.formula-range').forEach(setRangeProgress);
    setRangeProgress(els.coldDuration);
    root.querySelectorAll('.range-step-button').forEach(button => {
      const input = root.querySelector(`#${button.dataset.stepTarget}`);
      if (!input) return;
      const value = Number(input.value);
      button.disabled = button.dataset.stepDirection === 'down' ? value <= Number(input.min) : value >= Number(input.max);
    });
    els.levainToggle.querySelector('b').textContent = state.levain ? 'On' : 'Off';
  }

  function renderBulkDiagnostic(plan) {
    const rise = Math.round(plan.bulk.rise);
    const band = Object.values(everydayTempBands).find(band => plan.bulk.t <= band.max);
    const coldDough = band.max <= 70;
    els.tempRiseTarget.textContent = `Dough has grown by an extra ${rise}%`;
    els.bulkDuration.textContent = bulkTimeRange(band) + (coldDough ? ' or even longer' : '');
    els.bulkColdNote.textContent = coldDoughNote;
    els.bulkColdNote.hidden = !coldDough;
    els.bulkFinish.textContent = formatDayTime(plan.bulkEnd);
  }

  function parseBakeAt() {
    const raw = els.bakeAt.value || localInputValue(nextDayNine());
    const [datePart, timePart = '09:00'] = raw.split('T');
    const [year, month, day] = datePart.split('-').map(Number);
    const [hour, minute] = timePart.split(':').map(Number);
    return new Date(year, month - 1, day, hour, minute, 0, 0);
  }

  function getPlan(bulk, values) {
    const finalProofHours = state.proofMode === 'cold'
      ? (state.mode === 'everyday' ? 12 : clamp(num(els.coldHours, 12), 12, 48))
      : constants.warmProofHours;
    const starterPrereqHours = state.starterState === 'feed'
      ? starterFeedOptions[state.starterFeedRatio].hours
      : state.starterState === 'hibernating'
        ? constants.hibernationHours
        : 0;
    const prereq = starterPrereqHours + (state.levain ? values.levainHours : 0);
    const afterDoughStart = bulk.h + constants.shapeHours + finalProofHours;

    let doughStart;
    let bakeStart;
    if (state.scheduleMode === 'now') {
      const start = new Date(state.startNowAt);
      start.setSeconds(0, 0);
      doughStart = addHours(start, prereq);
      bakeStart = addHours(doughStart, afterDoughStart);
    } else {
      bakeStart = parseBakeAt();
      doughStart = addHours(bakeStart, -afterDoughStart);
    }

    let cursor = addHours(doughStart, -prereq);
    const events = [];
    let activationStart = null;
    let levainStart = null;

    if (state.starterState === 'feed') {
      activationStart = new Date(cursor);
      const feedHours = starterFeedOptions[state.starterFeedRatio].hours;
      const end = addHours(cursor, feedHours);
      events.push({name: 'Feed starter', cls: 'activate', start: new Date(cursor), end, detail: `${copy.activate} Current plan: ${state.starterFeedRatio}, about ${feedHours} hours around 74°F.`});
      cursor = end;
    } else if (state.starterState === 'hibernating') {
      activationStart = new Date(cursor);
      const end = addHours(cursor, constants.hibernationHours);
      events.push({name: 'Wake starter', cls: 'activate', start: new Date(cursor), end, detail: 'A starter refrigerated for a month or more may need a couple of feedings. It is ready when it becomes bubbly within several hours after feeding and doubles in volume. This 24-hour block is only a planning allowance.'});
      cursor = end;
    }

    if (state.levain) {
      levainStart = new Date(cursor);
      const end = addHours(cursor, values.levainHours);
      events.push({name: 'Build levain', cls: 'levain', start: new Date(cursor), end, detail: copy.levain});
      cursor = end;
    }

    const mixEnd = addHours(doughStart, constants.mixHours);
    const bulkEnd = addHours(doughStart, bulk.h);
    const shapeEnd = addHours(bulkEnd, constants.shapeHours);
    const proofEnd = addHours(shapeEnd, finalProofHours);
    const bakeEnd = addHours(bakeStart, constants.bakeHours);
    const rise = Math.round(bulk.rise);

    events.push({name: 'Mix ingredients', cls: 'mix', start: doughStart, end: mixEnd, detail: copy.mix});
    events.push({name: 'Bulk ferment', cls: 'bulk', start: mixEnd, end: bulkEnd, detail: withRise(copy.bulkTooltip, rise)});
    events.push({name: 'Shape', cls: 'shape', start: bulkEnd, end: shapeEnd, detail: copy.shape});

    if (state.proofMode === 'cold') {
      events.push({name: 'Cold proof', cls: 'cold', start: shapeEnd, end: proofEnd, detail: `${copy.coldProof} Current plan: about ${Math.round(finalProofHours)} hours.`});
    } else {
      events.push({name: 'Warm proof', cls: 'warm', start: shapeEnd, end: proofEnd, detail: `${copy.warmProof} Current plan: about ${constants.warmProofHours} hours around ${constants.warmProofTemp}°F.`});
    }
    events.push({name: 'Bake', cls: 'bake', start: bakeStart, end: bakeEnd, detail: copy.bake});

    const folds = [1, 1.5, 2].map(hours => addHours(doughStart, hours)).filter(date => date < bulkEnd);
    return {
      bulk,
      events,
      folds,
      planStart: events[0].start,
      bakeStart,
      bakeEnd,
      doughStart,
      bulkEnd,
      shapeEnd,
      activationStart,
      levainStart,
      finalProofHours,
      levainHours: values.levainHours
    };
  }

  function relativeDay(date) {
    const today = startOfDay(new Date());
    const target = startOfDay(date);
    const dayDifference = Math.round((target - today) / 86400000);
    if (dayDifference === 0) return 'Today';
    if (dayDifference === 1) return 'Tomorrow';
    return new Intl.DateTimeFormat(undefined, {weekday: 'long', month: 'short', day: 'numeric'}).format(date);
  }

  function nextMoveCopy(name, rise) {
    if (name === 'Feed starter') return `Feed it at ${state.starterFeedRatio}, then use it when it is visibly risen, bubbly and near peak activity.`;
    if (name === 'Wake starter') return 'Give your starter time and feedings to become bubbly within several hours and double in volume.';
    if (name === 'Build levain') return 'Combine your levain ingredients and use it when well risen and aerated.';
    if (name === 'Mix ingredients') return 'Your starter is ready. Mix the dough and begin bulk fermentation.';
    if (name === 'Bulk ferment') return `Start inspecting around this time; look for roughly ${rise}% additional rise and the other readiness signs.`;
    if (name === 'Shape') return state.proofMode === 'cold' ? 'Shape the loaf, then move it to the refrigerator.' : 'Shape the loaf, then begin the final counter proof.';
    if (name === 'Cold proof') return 'Let the shaped loaf rest cold until bake time.';
    if (name === 'Warm proof') return 'Use the dough as the final cue rather than the timer alone.';
    return 'Preheat thoroughly, score the loaf and bake.';
  }

  function moveTimeHtml(date) {
    const rounded = roundToQuarter(date);
    return `<span class="move-day">${escapeHtml(formatDayShort(rounded))}</span><strong class="move-time">${escapeHtml(formatTime(rounded))}</strong>`;
  }

  function moveRow(date, title, detail = '', anchor = '', imageUrl = '') {
    const detailHtml = detail ? `<span class="move-detail">${escapeHtml(detail)}</span>` : '';
    const image = imageUrl
      ? `<span class="move-image"><img src="${escapeHtml(imageUrl)}" alt="" loading="lazy" decoding="async"></span>`
      : '<span class="move-image move-image-empty" aria-hidden="true"></span>';
    const href = anchor || '#recipeSection';
    return `<div class="move-line"><a class="move-link" href="${escapeHtml(href)}">${image}<span class="move-when">${moveTimeHtml(date)}</span><span class="move-copy"><span class="move-title">${escapeHtml(title)}<span class="move-link-arrow" aria-hidden="true">↘</span></span>${detailHtml}</span></a></div>`;
  }

  function renderNextMove(plan) {
    const rise = Math.round(plan.bulk.rise);
    const first = plan.events[0];
    els.nextMoveTime.textContent = `${relativeDay(first.start)} · ${formatTime(roundToQuarter(first.start))}`;
    els.nextMoveTitle.textContent = first.name;
    els.nextMoveDetail.textContent = nextMoveCopy(first.name, rise);

    const feedHours = starterFeedOptions[state.starterFeedRatio].hours;
    els.starterFeedTiming.textContent = state.starterState === 'feed'
      ? `+${feedHours} hours for starter activation`
      : '';

    els.starterStateNote.hidden = state.starterState !== 'hibernating';
    els.starterStateNote.textContent = state.starterState === 'hibernating'
      ? `Starter that has been in the fridge for a month or more may need several feedings each day for 1-7 days. You know it's ready when it looks bubbly within several hours after feeding, and has grown to 2x-3x. It should have it's pleasant sour tang smell back, and it should be past it's growth phase and the domed top has flattened and settled down. This planner adds 24 hours for waking the starter, but it can take up to a week, so for more accurate timing we recommend coming back when your starter is active and choosing “Active & Ready.”`
      : '';

    const lines = [];
    if (plan.activationStart) {
      const activationTitle = state.starterState === 'hibernating' ? 'Wake starter' : 'Feed starter';
      const activationHours = state.starterState === 'hibernating' ? constants.hibernationHours : feedHours;
      lines.push(moveRow(plan.activationStart, activationTitle, `Allow about ${activationHours} hr`, '#guide-step-01', scheduleImages.starter));
    }
    if (state.levain && plan.levainStart) lines.push(moveRow(plan.levainStart, 'Build levain', `Allow about ${plan.levainHours} hr`, '#guide-step-02', scheduleImages.levain));
    lines.push(moveRow(plan.doughStart, 'Mix & fold', '', '#guide-step-03', scheduleImages.mix));
    lines.push(moveRow(plan.bulkEnd, 'Check bulk fermentation', withRise(copy.bulkNext, rise), '#bulkFermentGuide', scheduleImages.bulk));
    lines.push(moveRow(plan.bulkEnd, 'Shape', '', '#guide-step-05', scheduleImages.shape));
    lines.push(moveRow(plan.shapeEnd, state.proofMode === 'cold' ? 'Cold proof' : 'Proof on counter', state.proofMode === 'cold' ? `About ${Math.round(plan.finalProofHours)} hr` : `About ${constants.warmProofHours} hr`, '#guide-step-06', scheduleImages.proof));
    lines.push(moveRow(plan.bakeStart, 'Score & bake', '', '#guide-step-07', scheduleImages.bake));
    els.moveList.innerHTML = lines.join('');
  }

  function renderTimeline(plan) {
    const firstDay = startOfDay(plan.planStart);
    const elapsedDays = Math.ceil((plan.bakeEnd - firstDay) / 86400000);
    const dayCount = Math.max(2, elapsedDays);
    const now = new Date();
    els.timeline.innerHTML = '';

    for (let i = 0; i < dayCount; i++) {
      const dayStart = addHours(firstDay, i * 24);
      const dayEnd = addHours(dayStart, 24);
      const row = document.createElement('div');
      row.className = 'day';
      row.innerHTML = `<div class="day-label"><strong>${escapeHtml(formatDayShort(dayStart))}</strong><span>${escapeHtml(new Intl.DateTimeFormat(undefined, {month: 'short', day: 'numeric'}).format(dayStart))}</span></div><div class="track"><div class="hours"></div></div>`;
      const track = row.querySelector('.track');
      const hours = row.querySelector('.hours');

      for (let h = 0; h < 24; h += 3) {
        const label = document.createElement('span');
        label.className = 'hour-label';
        label.style.left = `${((h + .5) / 24) * 100}%`;
        label.textContent = h === 0 ? '12a' : h < 12 ? `${h}a` : h === 12 ? '12p' : `${h - 12}p`;
        hours.appendChild(label);
      }

      plan.events.forEach(event => {
        const start = new Date(Math.max(event.start.getTime(), dayStart.getTime()));
        const end = new Date(Math.min(event.end.getTime(), dayEnd.getTime()));
        if (end <= start) return;
        const block = document.createElement('div');
        block.className = `event ${event.cls}`;
        block.style.left = `${((start - dayStart) / 86400000) * 100}%`;
        block.style.width = `${((end - start) / 86400000) * 100}%`;
        const timeText = `${formatTime(event.start)}–${formatTime(event.end)}`;
        block.innerHTML = `<span>${escapeHtml(event.name)}</span><small>${escapeHtml(timeText)}</small>`;
        block.dataset.tooltip = `${event.name} · ${timeText}\n${event.detail}`;
        block.tabIndex = 0;
        track.appendChild(block);
      });

      plan.folds.forEach((fold, index) => {
        if (fold < dayStart || fold >= dayEnd) return;
        const marker = document.createElement('div');
        marker.className = 'marker fold';
        marker.style.left = `${((fold - dayStart) / 86400000) * 100}%`;
        marker.textContent = '★';
        marker.setAttribute('aria-label', `Fold ${index + 1} at ${formatTime(fold)}`);
        marker.dataset.tooltip = `Fold ${index + 1} · ${formatTime(fold)}`;
        marker.tabIndex = 0;
        track.appendChild(marker);
      });

      if (now >= dayStart && now < dayEnd) {
        const line = document.createElement('div');
        line.className = 'now-line';
        line.style.left = `${((now - dayStart) / 86400000) * 100}%`;
        track.appendChild(line);
      }

      els.timeline.appendChild(row);
    }

    const invalidBakeTime = state.scheduleMode === 'bake' && plan.planStart < new Date();
    els.scheduleWarning.hidden = !invalidBakeTime;
    els.scheduleWarning.textContent = invalidBakeTime ? 'That bake time requires a start in the past. Choose a later bake time.' : '';

    if (els.timelineWrap.scrollWidth > els.timelineWrap.clientWidth) {
      const firstTrack = els.timeline.querySelector('.track');
      const dayLabel = els.timeline.querySelector('.day-label');
      if (firstTrack && dayLabel) {
        const hour = plan.planStart.getHours() + plan.planStart.getMinutes() / 60;
        const focusX = dayLabel.getBoundingClientRect().width + (hour / 24) * firstTrack.getBoundingClientRect().width;
        els.timelineWrap.scrollLeft = Math.max(0, focusX - els.timelineWrap.clientWidth * .22);
      }
    }
  }

  function render() {
    syncState();
    const values = recipeValues();
    const tempValue = state.mode === 'everyday'
      ? everydayTempBands[state.everydayTempBand].planTemp
      : clamp(num(els.temp, 74), 65, 80);
    const bulk = getChart(tempValue);
    const plan = getPlan(bulk, values);
    renderRecipe(values, bulk);
    renderEverydayTemperature();
    renderAdvancedControls();
    renderBulkDiagnostic(plan);
    renderNextMove(plan);
    renderTimeline(plan);
    requestAnimationFrame(updateJumpNav);
  }

  function enterCustomMode() {
    if (!state.customInitialized) {
      els.flour.value = String(clamp(Math.round(num(els.loaves, 1)), 1, 3) * 500);
      els.flourDirect.value = els.flour.value;
      els.hydrationDirect.value = els.hydration.value;
      els.starterPctDirect.value = els.starterPct.value;
      state.customInitialized = true;
    }
    setPressed(els.recipeMode, 'custom');
    render();
  }

  els.recipeMode.addEventListener('click', event => {
    const button = event.target.closest('button[data-value]');
    if (!button) return;
    if (button.dataset.value === 'custom') enterCustomMode();
    else {
      setPressed(els.recipeMode, 'everyday');
      render();
    }
  });

  els.loafChoice.addEventListener('click', event => {
    const button = event.target.closest('button[data-value]');
    if (!button) return;
    const value = clamp(Number(button.dataset.value), 1, 3);
    setPressed(els.loafChoice, value);
    els.loaves.value = String(value);
    render();
  });

  els.advancedToggles.forEach(toggle => {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      const panel = root.querySelector(`#${toggle.getAttribute('aria-controls')}`);
      toggle.setAttribute('aria-expanded', String(open));
      panel.hidden = !open;
      toggle.querySelector('.advanced-toggle-icon').textContent = open ? '−' : '＋';
    });
  });

  els.levainToggle.addEventListener('click', () => {
    const on = els.levainToggle.getAttribute('aria-pressed') !== 'true';
    els.levainToggle.setAttribute('aria-pressed', String(on));
    render();
  });

  els.everydayTempBand.addEventListener('click', event => {
    const button = event.target.closest('button[data-value]');
    if (!button) return;
    setPressed(els.everydayTempBand, button.dataset.value);
    render();
  });

  els.tempPresets.addEventListener('click', event => {
    const button = event.target.closest('button[data-value]');
    if (!button) return;
    els.temp.value = button.dataset.value;
    render();
  });

  root.addEventListener('click', event => {
    const button = event.target.closest('.range-step-button[data-step-target]');
    if (!button || button.disabled) return;
    const input = root.querySelector(`#${button.dataset.stepTarget}`);
    if (!input) return;
    if (button.dataset.stepDirection === 'down') input.stepDown();
    else input.stepUp();
    input.dispatchEvent(new Event('input', {bubbles: true}));
  });

  function bindDirectValue(directInput, rangeInput, allowOutsideRange = false) {
    const commit = () => {
      if (directInput.value === '') {
        directInput.value = rangeInput.value;
        render();
        return;
      }
      const value = Number(directInput.value);
      const min = Number(rangeInput.min);
      const max = Number(rangeInput.max);
      const step = Number(rangeInput.step) || 1;
      const decimals = (String(rangeInput.step).split('.')[1] || '').length;
      const snapped = clamp(min + Math.round((value - min) / step) * step, min, max);
      rangeInput.value = String(Number(snapped.toFixed(decimals)));
      if (!allowOutsideRange) directInput.value = rangeInput.value;
      render();
    };
    directInput.addEventListener('change', commit);
    directInput.addEventListener('keydown', event => {
      if (event.key === 'Enter') {
        event.preventDefault();
        directInput.blur();
      }
    });
  }

  bindDirectValue(els.flourDirect, els.flour, true);
  bindDirectValue(els.hydrationDirect, els.hydration, true);
  bindDirectValue(els.starterPctDirect, els.starterPct, true);
  bindDirectValue(els.saltPctDirect, els.saltPct);

  [els.proofMode, els.scheduleMode, els.starterState, els.starterFeedRatio].forEach(group => {
    group.addEventListener('click', event => {
      const button = event.target.closest('button[data-value]');
      if (!button) return;
      setPressed(group, button.dataset.value);
      if (group === els.scheduleMode && button.dataset.value === 'now') state.startNowAt = new Date();
      render();
    });
  });

  const directInputsByRange = new Map([
    [els.flour, els.flourDirect],
    [els.hydration, els.hydrationDirect],
    [els.starterPct, els.starterPctDirect]
  ]);

  [els.flour, els.hydration, els.starterPct, els.saltPct, els.levainFlourPct, els.levainWaterPct, els.levainSeedPct, els.temp, els.coldHours, els.bakeAt].forEach(input => {
    input.addEventListener('input', () => {
      const directInput = directInputsByRange.get(input);
      if (directInput) directInput.value = input.value;
      render();
    });
  });

  els.coldDuration.addEventListener('input', () => {
    const index = clamp(Math.round(num(els.coldDuration, 0)), 0, coldProofHours.length - 1);
    const hours = coldProofHours[index];
    els.coldHours.value = String(hours);
    render();
  });

  function pad2(n) { return String(n).padStart(2, '0'); }
  function dateKey(date) { return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`; }

  function writeBakeAt(date) {
    const rounded = new Date(date);
    rounded.setSeconds(0, 0);
    els.bakeAt.value = localInputValue(rounded);
    els.bakeDateButton.textContent = new Intl.DateTimeFormat(undefined, {weekday: 'long', month: 'short', day: 'numeric'}).format(rounded);
    els.bakeTime.value = `${pad2(rounded.getHours())}:${pad2(rounded.getMinutes())}`;
  }

  function populateBakeTimes() {
    for (let minutes = 0; minutes < 24 * 60; minutes += 30) {
      const hour = Math.floor(minutes / 60);
      const minute = minutes % 60;
      const option = document.createElement('option');
      option.value = `${pad2(hour)}:${pad2(minute)}`;
      option.textContent = new Intl.DateTimeFormat(undefined, {hour: 'numeric', minute: '2-digit'}).format(new Date(2000, 0, 1, hour, minute));
      els.bakeTime.appendChild(option);
    }
  }

  function renderCalendar() {
    const selectedDate = parseBakeAt();
    const cursor = state.calendarCursor || new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);
    state.calendarCursor = new Date(cursor.getFullYear(), cursor.getMonth(), 1);
    els.calendarMonth.textContent = new Intl.DateTimeFormat(undefined, {month: 'long', year: 'numeric'}).format(state.calendarCursor);
    els.calendarGrid.innerHTML = '';
    const first = new Date(state.calendarCursor.getFullYear(), state.calendarCursor.getMonth(), 1);
    const gridStart = new Date(first);
    gridStart.setDate(first.getDate() - first.getDay());
    const today = startOfDay(new Date());

    for (let i = 0; i < 42; i++) {
      const date = new Date(gridStart);
      date.setDate(gridStart.getDate() + i);
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = String(date.getDate());
      button.dataset.date = dateKey(date);
      button.setAttribute('aria-label', new Intl.DateTimeFormat(undefined, {weekday: 'long', month: 'long', day: 'numeric', year: 'numeric'}).format(date));
      button.className = 'calendar-day';
      if (date.getMonth() !== state.calendarCursor.getMonth()) button.classList.add('other-month');
      if (dateKey(date) === dateKey(selectedDate)) {
        button.classList.add('selected');
        button.setAttribute('aria-current', 'date');
      }
      if (dateKey(date) === dateKey(today)) button.classList.add('today');
      if (date < today) button.disabled = true;
      els.calendarGrid.appendChild(button);
    }
  }

  function openCalendar() {
    const selectedDate = parseBakeAt();
    state.calendarCursor = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);
    renderCalendar();
    els.bakeCalendar.hidden = false;
    els.bakeCalendar.classList.remove('open-up');
    if (window.matchMedia('(min-width:641px)').matches) {
      const buttonBox = els.bakeDateButton.getBoundingClientRect();
      const calendarHeight = els.bakeCalendar.getBoundingClientRect().height;
      if (buttonBox.bottom + calendarHeight + 14 > window.innerHeight && buttonBox.top > calendarHeight + 14) els.bakeCalendar.classList.add('open-up');
    }
    els.bakeDateButton.setAttribute('aria-expanded', 'true');
  }

  function closeCalendar() {
    els.bakeCalendar.hidden = true;
    els.bakeDateButton.setAttribute('aria-expanded', 'false');
  }

  els.bakeDateButton.addEventListener('click', () => els.bakeCalendar.hidden ? openCalendar() : closeCalendar());
  els.calendarPrev.addEventListener('click', () => {
    state.calendarCursor.setMonth(state.calendarCursor.getMonth() - 1);
    renderCalendar();
  });
  els.calendarNext.addEventListener('click', () => {
    state.calendarCursor.setMonth(state.calendarCursor.getMonth() + 1);
    renderCalendar();
  });
  els.calendarGrid.addEventListener('click', event => {
    const button = event.target.closest('button[data-date]');
    if (!button || button.disabled) return;
    const [year, month, day] = button.dataset.date.split('-').map(Number);
    const current = parseBakeAt();
    writeBakeAt(new Date(year, month - 1, day, current.getHours(), current.getMinutes()));
    closeCalendar();
    render();
  });
  els.bakeTime.addEventListener('change', () => {
    const current = parseBakeAt();
    const [hour, minute] = els.bakeTime.value.split(':').map(Number);
    writeBakeAt(new Date(current.getFullYear(), current.getMonth(), current.getDate(), hour, minute));
    render();
  });

  let tooltipTarget = null;
  let tooltipPinned = false;

  function tooltipText(target) { return target.dataset.tooltip || ''; }
  function positionTooltip(target, pointerEvent = null) {
    const pad = 12;
    const viewport = window.visualViewport;
    const viewportLeft = viewport ? viewport.offsetLeft : 0;
    const viewportTop = viewport ? viewport.offsetTop : 0;
    const viewportWidth = viewport ? viewport.width : window.innerWidth;
    const viewportHeight = viewport ? viewport.height : window.innerHeight;
    const viewportRight = viewportLeft + viewportWidth;
    const viewportBottom = viewportTop + viewportHeight;
    const box = els.eventTooltip.getBoundingClientRect();
    let x;
    let y;

    if (pointerEvent && pointerEvent.clientX != null) {
      x = pointerEvent.clientX + 12;
      y = pointerEvent.clientY + 12;
      if (x + box.width > viewportRight - pad) x = pointerEvent.clientX - box.width - 12;
      if (y + box.height > viewportBottom - pad) y = pointerEvent.clientY - box.height - 12;
    } else {
      const anchor = target.getBoundingClientRect();
      x = anchor.left + anchor.width / 2 - box.width / 2;
      y = anchor.top - box.height - 10;
      if (y < viewportTop + pad) y = anchor.bottom + 10;
    }

    x = clamp(x, viewportLeft + pad, Math.max(viewportLeft + pad, viewportRight - box.width - pad));
    y = clamp(y, viewportTop + pad, Math.max(viewportTop + pad, viewportBottom - box.height - pad));
    els.eventTooltip.style.left = `${x}px`;
    els.eventTooltip.style.top = `${y}px`;
  }

  function showTooltip(target, pointerEvent = null, pinned = false) {
    const text = tooltipText(target);
    if (!text) return;
    tooltipTarget = target;
    tooltipPinned = pinned;
    els.eventTooltip.textContent = text;
    els.eventTooltip.classList.add('show');
    positionTooltip(target, pointerEvent);
  }

  function hideTooltip(force = false) {
    if (tooltipPinned && !force) return;
    tooltipTarget = null;
    tooltipPinned = false;
    els.eventTooltip.classList.remove('show');
  }

  root.addEventListener('pointerover', event => {
    const target = event.target.closest('[data-tooltip]');
    if (!target || event.pointerType === 'touch') return;
    showTooltip(target, event, false);
  });
  root.addEventListener('pointermove', event => {
    if (!tooltipTarget || tooltipPinned || event.pointerType === 'touch') return;
    positionTooltip(tooltipTarget, event);
  });
  root.addEventListener('pointerout', event => {
    const target = event.target.closest('[data-tooltip]');
    if (!target || tooltipPinned || target.contains(event.relatedTarget)) return;
    hideTooltip();
  });
  root.addEventListener('focusin', event => {
    const target = event.target.closest('[data-tooltip]');
    if (target) showTooltip(target, null, false);
  });
  root.addEventListener('focusout', event => {
    const target = event.target.closest('[data-tooltip]');
    if (target && !tooltipPinned) hideTooltip();
  });
  root.addEventListener('click', event => {
    const target = event.target.closest('.event, .marker[data-tooltip]');
    if (!target || !tooltipText(target)) return;
    if (tooltipPinned && tooltipTarget === target) hideTooltip(true);
    else showTooltip(target, null, true);
  });

  function highlightGuideTarget(hash) {
    root.querySelectorAll('.guide-step-linked').forEach(step => step.classList.remove('guide-step-linked'));
    if (!hash || hash === '#') return;
    const target = document.getElementById(hash.slice(1));
    if (target && root.contains(target) && target.classList.contains('guide-step')) target.classList.add('guide-step-linked');
  }

  els.moveList.addEventListener('click', event => {
    const link = event.target.closest('a.move-link[href^="#"]');
    if (link) highlightGuideTarget(link.getAttribute('href'));
  });
  window.addEventListener('hashchange', () => highlightGuideTarget(window.location.hash));
  if (window.location.hash) highlightGuideTarget(window.location.hash);

  const jumpSections = [
    {label: 'Recipe', element: els.recipeSection},
    {label: 'Plan', element: els.planSection},
    {label: 'Timeline', element: els.actionStepsSection},
    {label: 'Instructions', element: els.instructionsSection}
  ].filter(section => section.element);

  function sectionIndexAtViewport() {
    const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    const probe = Math.min(viewportHeight * .42, 360);
    let index = 0;
    jumpSections.forEach((section, candidate) => {
      if (section.element.getBoundingClientRect().top <= probe) index = candidate;
    });
    return index;
  }

  function setJumpButton(button, section, direction) {
    button.dataset.jumpTarget = section.label;
    button.innerHTML = direction === 'up'
      ? `<span class="jump-arrow" aria-hidden="true">↑</span><span>${section.label}</span>`
      : `<span>${section.label}</span><span class="jump-arrow" aria-hidden="true">↓</span>`;
    button.onclick = () => {
      hideTooltip(true);
      section.element.scrollIntoView({behavior: 'smooth', block: 'start'});
    };
  }

  function updateJumpNav() {
    if (!els.jumpNav || !els.jumpNavFirst || !els.jumpNavSecond || jumpSections.length < 2) return;
    const current = sectionIndexAtViewport();
    let first;
    let second;

    if (current <= 0) {
      first = {section: jumpSections[1], direction: 'down'};
      second = {section: jumpSections[Math.min(2, jumpSections.length - 1)], direction: 'down'};
    } else if (current >= jumpSections.length - 1) {
      first = {section: jumpSections[Math.max(0, jumpSections.length - 3)], direction: 'up'};
      second = {section: jumpSections[jumpSections.length - 2], direction: 'up'};
    } else {
      first = {section: jumpSections[current - 1], direction: 'up'};
      second = {section: jumpSections[current + 1], direction: 'down'};
    }

    if (first.section === second.section) {
      const alternate = jumpSections.find(section => section !== first.section && section !== jumpSections[current]);
      if (alternate) second = {section: alternate, direction: alternate.element.getBoundingClientRect().top < 0 ? 'up' : 'down'};
    }

    setJumpButton(els.jumpNavFirst, first.section, first.direction);
    setJumpButton(els.jumpNavSecond, second.section, second.direction);
    els.jumpNav.hidden = false;
  }

  window.addEventListener('scroll', updateJumpNav, {passive: true});
  window.addEventListener('resize', updateJumpNav, {passive: true});
  if (window.visualViewport) window.visualViewport.addEventListener('resize', updateJumpNav);

  function mobileTimelineActive() {
    return window.matchMedia('(max-width: 640px)').matches;
  }

  function setTimelineExpanded(expanded) {
    state.timelineExpanded = mobileTimelineActive() && expanded;
    els.timelineWrap.classList.toggle('is-mobile-expanded', state.timelineExpanded);
    if (!state.timelineExpanded) els.timelineWrap.scrollLeft = 0;
  }

  els.timelineWrap.addEventListener('click', () => setTimelineExpanded(true));
  els.timelineWrap.addEventListener('focusin', () => setTimelineExpanded(true));
  els.timelineWrap.addEventListener('focusout', event => {
    if (!els.timelineWrap.contains(event.relatedTarget)) setTimelineExpanded(false);
  });
  window.addEventListener('resize', () => {
    if (!mobileTimelineActive()) setTimelineExpanded(false);
  }, {passive: true});

  function resetInitialControls() {
    root.querySelectorAll('input[value]').forEach(input => { input.value = input.getAttribute('value'); });
    setPressed(els.recipeMode, 'everyday');
    setPressed(els.loafChoice, '1');
    setPressed(els.scheduleMode, 'now');
    setPressed(els.starterState, 'active');
    setPressed(els.starterFeedRatio, '1:1:1');
    setPressed(els.everydayTempBand, '70-75');
    setPressed(els.proofMode, 'cold');
    setPressed(els.tempPresets, '74');
    els.levainToggle.setAttribute('aria-pressed', 'false');
    els.levainToggle.querySelector('b').textContent = 'Off';
    els.advancedToggles.forEach(toggle => {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.querySelector('.advanced-toggle-icon').textContent = '＋';
      root.querySelector(`#${toggle.getAttribute('aria-controls')}`).hidden = true;
    });
    setTimelineExpanded(false);
    state.mode = 'everyday';
    state.customInitialized = false;
    state.startNowAt = new Date();
    state.calendarCursor = null;
    closeCalendar();
  }

  document.addEventListener('pointerdown', event => {
    if (state.timelineExpanded && !event.target.closest('.timeline-wrap')) setTimelineExpanded(false);
    if (!els.bakeCalendar.hidden && !event.target.closest('.bake-date-wrap')) closeCalendar();
    if (tooltipPinned && tooltipTarget && !tooltipTarget.contains(event.target)) hideTooltip(true);
  });
  document.addEventListener('scroll', () => {
    if (tooltipTarget) hideTooltip(true);
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    closeCalendar();
    hideTooltip(true);
  });

  resetInitialControls();
  populateBakeTimes();
  writeBakeAt(nextDayNine());
  render();

  window.addEventListener('pageshow', () => {
    resetInitialControls();
    writeBakeAt(nextDayNine());
    render();
    requestAnimationFrame(updateJumpNav);
    });
})();
